module.exports = __webpack_public_path__ + "src/assets/audio/tractor.mp3";